import { render, staticRenderFns } from "./TabHeaderFilter.vue?vue&type=template&id=2da0e826&scoped=true"
import script from "./TabHeaderFilter.vue?vue&type=script&lang=js"
export * from "./TabHeaderFilter.vue?vue&type=script&lang=js"
import style0 from "./TabHeaderFilter.vue?vue&type=style&index=0&id=2da0e826&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da0e826",
  null
  
)

export default component.exports